import React from 'react'
import { Field, FieldProps } from 'formik'

import { DatetimeProps } from '@/components/controls/Datetime'
import { Placeholder } from '@/components/blocks/Placeholder'

const Datetime = React.lazy(() => import(/* webpackChunkName: 'json-editor' */ '@/components/controls/Datetime'))

interface DatetimeFieldProps extends DatetimeProps {
  name: string
}

const DatetimeField: React.FC<DatetimeFieldProps> = ({ disabled, ...props }) => (
  <Field {...props}>
    {({ field, form }: FieldProps<Date | null>) => {
      const { isSubmitting, errors } = form
      const onChange = (value: number | null) => {
        form.setFieldValue(field.name, value)
      }
      const error = errors[field.name] as string

      // Convert timestamp to Date object for display
      const dateValue = typeof field.value === 'number' ? new Date(field.value * (props.isMs ? 1 : 1000)) : field.value

      return (
        <React.Suspense fallback={<Placeholder height='40px' />}>
          <Datetime error={error} value={dateValue} {...props} disabled={isSubmitting || disabled} onChange={onChange} />
        </React.Suspense>
      )
    }}
  </Field>
)

export default DatetimeField
